export default {
  ru: {
    map: 'Навигация',
    schedule: 'Расписание тренировок',
    enroll: 'Записаться на тренировку',
    trainings: 'Больше про тренировки',
  },
  en: {
    // en
  },
};
